import React from 'react';

import { GoArrowLeft } from "react-icons/go";
import { LanguageSelector } from './LanguageSelector';
import { useLanguage } from './LanguageContext';
import AuthContext from "store/AuthContext";
import "./DimensionHeader.css";

const DimensionHeader: React.FC<{dimId: string, title: string, onBack?: (event: React.MouseEvent<HTMLDivElement>)=> void}> = (props) => {
    const authCtx = React.useContext(AuthContext);
    const [title, setTitle] = React.useState<string>(props.title);
    const [isHome, setIsHome] = React.useState<boolean>(true);
    const langCtx = useLanguage();
    
    const sendMessageToIframes = (message: any) => {
        for (let i = 0; i < window.frames.length; i++) {
            window.frames[i].postMessage(message, '*');
        }
    };

    const onWindowMessage = (event: MessageEvent<any>) => {
        if (event?.data.type == 'DIMENSION_NAV_BAR_UPDATE') {
            if (event.data.title === undefined || event.data.title === null) {
                setTitle(props.title)
                setIsHome(true)
            } else {
                setTitle(event.data.title)
                setIsHome(false)
            }
        }
    }

    React.useEffect(() => {
        window.addEventListener('message', onWindowMessage);
        return () => {
            window.removeEventListener('message', onWindowMessage);
        };
    }, []);

    const onBackClick = (event: React.MouseEvent<HTMLDivElement>) => {
        if(isHome) {
            props.onBack?.(event)
        } else {
            sendMessageToIframes({ type: 'DIMENSION_NAV_BAR_BACK' })
        }
    }

    // block go back for home karmiel page
    const canGoBack = !(isHome && props.dimId === '3382710084') || authCtx.account.developer;
    
    return (
        <div className="dim-nav-container">
            <div className='dim-nav-left' 
                onClick={ canGoBack ? onBackClick : undefined}
                style={{ cursor: canGoBack ? 'pointer' : 'default' }}
            >
                <div className='dim-nav-arrow'>
                    {canGoBack && (
                        <GoArrowLeft style={{ marginRight: '5px' }} />
                    )}
                </div>
                <span>{langCtx.translate(title)}</span>
            </div>

            <div className='dim-nav-right'>
                {isHome && props.dimId == '3382710084' && (
                    <LanguageSelector/>
                )}
            </div>
            
         
        </div>
    );
};

export default DimensionHeader;
